import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Footer } from '@pages/principal/footer/footer';
import { Nav } from '@pages/principal/nav/nav';

@Component({
    selector: 'app-data-deletion',
    standalone: true,
    imports: [Nav, Footer, RouterLink],
    templateUrl: './data-deletion.component.html',
    styleUrl: './data-deletion.component.scss'
})
export class DataDeletionComponent {

}
